import { render, staticRenderFns } from "./RegWithoutCardInfoText.vue?vue&type=template&id=0d0f6b9a&"
import script from "./RegWithoutCardInfoText.vue?vue&type=script&lang=ts&"
export * from "./RegWithoutCardInfoText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports